/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { HULocalizationProvider } from '../../components/HULocalizationProvider/HULocalizationProvider';
import { HUSnackbarProvider } from '../../components/HUSnackbarProvider/HUSnackbarProvider';
import { AdminSectionRoutes } from './AdminSectionRoutes';

export function AdminSectionController() {
  return (
    <HULocalizationProvider>
      <HUSnackbarProvider>
        <AdminSectionRoutes />
      </HUSnackbarProvider>
    </HULocalizationProvider>
  );
}
